const ROLE_WRITER = 'ROLE_WRITER';
const ROLE_EDITOR = 'ROLE_EDITOR';

export { ROLE_WRITER, ROLE_EDITOR };
